<template>
  <div class="page-card">
    <slot name="tab"/>
    <div class="page-card_head" v-if="!noHead">
      <slot name="header"/>
    </div>
    <div class="page-card_body">
      <slot name="body"/>
    </div>
  </div>
</template>

<script>
export default {
  props:["noHead"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
  },
};
</script>
<style scoped lang="scss">
.page-card{
  background:#fff;
  border-radius: 4px;
  margin-bottom: 40px;
  .page-card_head{
    padding:0.24rem 0.32rem;
    border-bottom:1px solid #F0F0F0;
    font-size: 0.22rem;
    font-weight: bold;
  }
  .page-card_body{
    padding:0.24rem 0.32rem;
  }

  &.no-padding{
    .page-card_body,
    .page-card_head{
      padding:0;
    }
  }
}

</style>
